import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none",
  viewBox: "0 0 33 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#E37300",
        d: "M16.5 3.539c-7.36 0-13.333 5.973-13.333 13.333 0 1.773.346 3.48.986 5.027l7.014-7.027 4.4 3.707 4.373-4.373h-2.107v-2.667H24.5v6.667h-2.667v-2.107l-6.12 6.107-4.386-3.72-5.867 5.866a13.33 13.33 0 0 0 11.04 5.854h10.667c1.466 0 2.666-1.2 2.666-2.667V16.872c0-7.36-5.973-13.333-13.333-13.333m10 24.667c-.733 0-1.333-.6-1.333-1.334 0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333-.6 1.334-1.333 1.334"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.5.872h32v32H.5z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }